import React from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaRegTrashAlt } from "react-icons/fa";
import { removeFromCart } from "../redux/store/cartSlice";
import { toast } from "react-toastify";
const CartDrawer = ({ onClose }) => {
  const { cartItems } = useSelector((state) => state.cart);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <div>
      {/* Background overlay */}
      <div className="fixed inset-0 bg-black/50 z-40" onClick={onClose} />

      {/* Modal container */}
      <div
        className="fixed right-0 top-0 w-4/5 md:w-[500px] h-screen bg-white p-2 md:p-4 z-50 shadow-lg flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-4 border-b border-b-gray-500 pb-3">
          <h2 className="font-semibold text-[20px] md:text-[24px] text-Syne">
            Recently added item(s)
          </h2>
          <button onClick={onClose} className="text-gray-700 text-2xl">
            <IoMdClose />
          </button>
        </div>

        {/* Cart Items (SCROLL AREA) */}
        <div className="overflow-y-auto flex flex-col gap-4 pr-2">
          {cartItems?.map((item) => (
            <div
              key={item.cartKey || item.id}
              className="flex justify-between items-start py-4 shadow-md"
            >
              <div className="flex gap-2">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-16 h-16 object-cover"
                />
                <div className="flex flex-col justify-center gap-1">
                  <h1 className="font-semibold text-[17px]">{item.title}</h1>
                  <p className="font-light text-[16px]">{item.vendor}</p>
                  {item.variantTitle && (
                    <p className="text-[13px] text-gray-500">
                      {item.variantTitle}
                    </p>
                  )}
                  <p className="text-[13px] text-gray-500">
                    Qty: {item.quantity}
                  </p>
                </div>
              </div>

              <div className="flex flex-col gap-4 w-[60px] mt-3">
                <h2 className="text-gray-500 text-[18px]">
                  $ {Number(item.unitPrice || item.variants?.[0]?.price || 0)}
                </h2>
                <button
                  onClick={() => {
                    dispatch(removeFromCart(item.cartKey || item.id));
                    toast.success("Item removed from cart", {
                      autoClose: 3000,
                      closeButton: false,
                      hideProgressBar: false,
                    });
                    // Close drawer after a brief delay to allow toast to render
                    setTimeout(() => {
                      onClose();
                    }, 500);
                  }}
                >
                  <FaRegTrashAlt size={20} color="#ef4444" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Buttons (FIXED AT BOTTOM) */}
        <div className=" pb-4 mt-[2rem] border-t flex justify-center flex-wrap items-center gap-2 md:gap-4">
          <button
            onClick={onClose}
            className="w-[130px] md:w-[200px] bg-black text-white text-[14px] md:text-[18px] py-2 md:py-4 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 active:scale-95"
          >
            Continue Shopping
          </button>
          <button
            onClick={() => navigate("/checkout")}
            className="w-[130px] md:w-[200px] bg-black text-white text-[14px] md:text-[18px] py-2 md:py-4 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 active:scale-95"
          >
            Process Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartDrawer;
